import {
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from "@ht/components";
import clsx from "clsx";
import { useAppSelector } from "../../../app/hooks";
import getInitials from "../../../utils/getInitials";
import { s } from "@ht/shared/methods";
export interface UserDropdownProps {
    userId?: string;
    username?: string;
    fullname?: string;
    profilePicture?: string;
    deviceId?: string;
    roleDescription?: string;
    customStyle1?: string;
    customStyle2?: string;
}

const UserDropdown = ({ fullname, roleDescription, profilePicture, customStyle1, customStyle2 }: UserDropdownProps) => {
    const iconClass = "text-xl mr-2 text-primary w-[1.125rem] text-center";
    const { user } = useAppSelector((state) => state.auth);
    const urlAuth = process.env.REACT_APP_AUTH_SERVICE;
    return (
        <Dropdown direction="down" className="ml-[0.938rem]" shape>
            <DropdownToggle
                variant="texted"
                color="light"
                iconClass="hidden md:inline-block"
                className="inline-flex items-center mt-[6px]"
            >
                {profilePicture ? <img
                    src={`${urlAuth?.replace(/\/$/, "")}/photos/${user?.username.toLowerCase()}/${profilePicture}`}
                    alt="user"
                    className="w-[32px] h-[32px] rounded-full"
                    width={32}
                    height={32}
                /> :
                    <div className="bg-primary-500 rounded-full w-9 h-9 flex text-white items-center justify-center text-base font-medium">
                        <span>
                            {getInitials(s(fullname ?? ""))}
                        </span>
                    </div>
                }
                <div className="flex flex-col items-start">
                    <span className={clsx("pl-2.5 hidden md:inline-block text-white text-base font-semibold", customStyle1)}>
                        {s(fullname)}
                    </span>
                    <span className={clsx("pl-2.5 hidden md:inline-block text-primary-100 text-base font-semibold", customStyle2)}>
                        {roleDescription}
                    </span>
                </div>

            </DropdownToggle>
            <DropdownMenu
                className={clsx(
                    "p-[0.625rem] w-[12.5rem] mt-3 -mr-[0.938rem] border-t-0 maxSm:right-4 sm:right-0 left-auto rounded-none"
                )}
            >
                <DropdownItem path="/profile">
                    <i className={clsx("icon ion-person", iconClass)} />
                    <span>View Profile</span>
                </DropdownItem>
                <DropdownItem path="/signout">
                    <i className={clsx("icon ion-forward", iconClass)} /> 
                    <span>Sign Out</span>
                </DropdownItem>
            </DropdownMenu>
        </Dropdown>
    );
};

export default UserDropdown;
